<template>
  <div>
    <el-dialog
      v-if="visible"
      v-el-dialog-drag
      show-close
      :visible="visible"
      append-to-body
      width="1000px"
      top="5vh"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => (backDialogVisible = true)"
    >
      <Main
        ref="main"
        :data="data"
        :errorKeys="errorKeys"
        @close="close"
        @reload="$emit('reload')"
        @delete="onMainDelete"
      />
      <span slot="footer">
        <el-button size="small" @click="() => (backDialogVisible = true)">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <ChooseShipmentPlanDialog
      :visible.sync="chooseShipmentPlanOptions.visible"
      :custCode="chooseShipmentPlanOptions.code"
      :endCustCode="chooseShipmentPlanOptions.endCustCode"
      @confirm="onShipmentPlanConfirm"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import ChooseShipmentPlanDialog from '../choose-shipment-plan/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, ChooseShipmentPlanDialog },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      backDialogVisible: false,
      errorKeys: [],
      chooseShipmentPlanOptions: {
        visible: false,
        code: '',
        endCustCode: ''
      },
    }
  },
  methods: {
    async save() {
      const formData = await this.$refs.main.getData()
      if (!formData) return (this.backDialogVisible = false)

      if (!this.data || !this.data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }

      const { custCode, endCustCode } = formData

      this.errorKeys = this.data
        .filter((i) => i.custCode != custCode || i.endCustCode != endCustCode)
        .map((i) => i.orderBatchCode)

      if (this.errorKeys && this.errorKeys.length) {
        this.$message({
          showClose: true,
          message: '存在不同下单客户或终端客户的数据',
          type: 'error',
        })
        return
      }

      this.loadingOpen()
      this.$api
        .shipmentInfoGenerateShipmentApi(formData)
        .then((res) => {
          this.loadingClose()
          const { data } = res.body
          if (data) {
            this.$message({
              showClose: true,
              message: '数据未通过校验!',
              type: 'warning',
            })

            this.errorKeys = data
              .filter((i) => !!i.errorMsg)
              .map((i) => i.orderBatchCode)
            this.$emit('update:data', data)
            return
          }
          this.$api
            .shipmentInfoChooseByDraftApi({
              custCode: custCode,
              endCustCode
            })
            .then((res) => {
              const custData = res.body.data
              if (custData && custData.length > 0) {
                this.chooseShipmentPlanOptions = {
                  visible: true,
                  code: custCode,
                  endCustCode
                }
              } else {
                this.onShipmentPlanConfirm({})
              }
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async onShipmentPlanConfirm({ shipmentCode }) {
      const formData = await this.$refs.main.getData()
      if (!formData) return

      this.loadingOpen()
      this.$api
        .shipmentInfoAddByBatchListApi({
          ...formData,
          shipmentCode,
        })
        .then(() => {
          this.loadingClose()
          this.$emit('reload')
          this.$message({
            showClose: true,
            message: '确认发运成功!',
            type: 'success',
          })
          this.close()
          this.onMainDelete(this.data)
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    onMainDelete(e) {
      this.$emit('delete', e)
    },
    close() {
      this.errorKeys = []
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
